import classNames from "classnames";
import Avatar from "rivals/components/shared/Avatar";
import Link from "rivals/components/shared/Link";
import Stars from "rivals/components/shared/Stars";
import TextCell from "rivals/components/shared/Tables/Cells/TextCell";
import { SHAPES } from "rivals/shared/constants";
import { CareerType } from "rivals/shared/interfaces/Career";
import styles from "./AthleteCell.module.scss";
import type { Props } from "./types";

// Athlete bio data cell - applicable for all athlete rank tables
const AthleteCell = ({
  careerType,
  className,
  firstName,
  href,
  imageUrl,
  lastName,
  stars
}: Props): React.JSX.Element => {
  const variant = careerType == CareerType.COLLEGE_PLAYER ? "blue" : "yellow";
  const starsComponent = (
    <Stars className={styles.personRating} numStars={stars} variant={variant} />
  );
  const name = (
    <div className={styles.nameContainer}>
      <span className={styles.name}>{firstName}</span>
      <span>{lastName}</span>
    </div>
  );

  const content = (
    <div className={classNames(className, styles.personDetailsWrapper)}>
      <span className={styles.profileImg}>
        <Avatar
          alt="transfer tracker"
          shape={SHAPES.CIRCLE}
          size={40}
          url={imageUrl}
        />
      </span>
      <TextCell bold footer={starsComponent} text={name} uppercase={false} />
    </div>
  );

  if (href) {
    return <Link href={href}>{content}</Link>;
  }

  return content;
};

export default AthleteCell;
